"use client";

import * as React from "react";
import { Clock, ShieldCheck, Scale, Anchor, FileText, Settings } from "lucide-react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const commitmentsData = [{
  title: "24/7 Brokerage Support",
  content: "Operating around the clock, Venchandlers Nexus provides 24/7 brokerage and operational support. We coordinate immediate acknowledgment of all supply requests and ensure rapid turnaround times for detailed procurement quotes from our global network, keeping your vessel's schedule on track.",
  icon: Clock
}, {
  title: "Quality Assurance through Trusted Supplier Network",
  content: "We coordinate the procurement of marine fuel, spare parts, and provisions through a strictly vetted global network. Our coordination ensures that all technical service providers and suppliers meet rigorous international maritime standards for quality and reliability.",
  icon: ShieldCheck
}, {
  title: "Brokerage & Pricing Transparency",
  content: "We operate with complete financial and operational transparency. Our clients receive itemized procurement quotes from global maritime partners and clear brokerage terms. We ensure full visibility in our coordination process, fostering long-term trust with fleet managers.",
  icon: Scale
}, {
  title: "Logistics & Delivery Coordination",
  content: "Leveraging our deep regional knowledge in the Atlantic and Caribbean regions, we coordinate timely and accurate delivery through trusted logistics partners. We oversee the entire process to ensure your vessel's requirements are met with precision and minimal downtime.",
  icon: Anchor
}, {
  title: "Technical services",
  content: "We coordinate specialized technical marine services, including engine repairs, underwater inspections, and hull maintenance, through our network of certified maritime engineers and technicians.",
  icon: Settings
}];
export default function ServiceCommitments() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: accordionRef,
    isVisible: isAccordionVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="service-commitments" className="dark bg-background text-foreground py-20 md:py-32 relative overflow-hidden">
      {}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-5xl h-[500px] bg-primary/5 blur-[120px] rounded-full pointer-events-none" />

      <div className="container mx-auto px-4 md:px-6 max-w-4xl relative z-10">
        
        <div ref={headerRef} className={`text-center mb-12 md:mb-16 transition-all duration-700 ease-out ${isHeaderVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <div className="inline-flex items-center justify-center p-3 bg-card border border-border rounded-full mb-6 shadow-sm">
            <FileText className="size-6 text-primary" />
          </div>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif font-bold tracking-tight mb-6 text-foreground">
            Service Level Commitments
          </h2>
          <p className="text-muted-foreground text-lg md:text-xl max-w-2xl mx-auto leading-relaxed">
            As a premier maritime brokerage and coordination platform, we leverage a global supplier network and technical service coordination to meet strict international maritime requirements.
          </p>
        </div>

        <div ref={accordionRef} className={`transition-all duration-700 delay-200 ease-out ${isAccordionVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          {}
          <div className="bg-card border border-border/50 rounded-xl p-6 md:p-10 shadow-2xl">
            <Accordion type="single" collapsible className="w-full" defaultValue="item-0">
              {commitmentsData.map((item, i) => {
              const Icon = item.icon;
              return <AccordionItem key={i} value={`item-${i}`} data-index={i} className="border-border/40 py-2">
                    <AccordionTrigger className="text-base md:text-lg font-semibold hover:text-primary transition-colors hover:no-underline group">
                      <div className="flex items-center gap-4 text-left">
                        <div className="p-2 rounded-md bg-background border border-border/50 text-muted-foreground group-hover:text-primary group-hover:border-primary/30 transition-colors">
                          <Icon className="size-5" />
                        </div>
                        {item.title}
                      </div>
                    </AccordionTrigger>
                    <AccordionContent className="text-muted-foreground text-base leading-relaxed pt-2 pb-6 pl-14 pr-4">
                      {item.content}
                    </AccordionContent>
                  </AccordionItem>;
            })}
            </Accordion>
          </div>

          <div className="mt-12 flex justify-center">
            <Button asChild size="lg" className="font-serif tracking-wide shadow-lg shadow-primary/20">
              <Link to="#quote-form">
                Review Coordination Terms
              </Link>
            </Button>
          </div>
        </div>

      </div>
    </section>;
}